import { Injectable } from '@nestjs/common';
import { DrrRequest, CategoryDetails, SubcategoryDetails, DrrDetails, DateDevIdClientCodeIsTotalReq, TotalSubCatWiseActBudgetRevResponse, TotalSubCategoryActBudRevenue, DrrDetailsResponse, SubCategoryWiseActRevenueResponse, SubCategoryWiseActRevenue, SubCategoryWiseActAndBudgetRevenueReq, SubCategoryWiseActAndBudgetRevenueResponse, SubCategoryWiseActAndBudgetRevenueDetails, CategoryWiseActAndBudgetForLastThreeYears, CategoryWiseActAndBudgetForLastThreeYrsDetails, CategoryWiseActAndBudgetForLastThreeYrsResponse, TotalVOBandVOLYDetailsReq, TotalVOBandVolyDetailsResponse, TotalVOBandVolyDetails, revenueDetailsByCategoryReq, RevenueDetailsByCategoryResponse, RevenueDetailsByCategoryDetails, CountBySubCategoryGroupReq, CountBySubCategoriesResponse, CountBySubCategoriesDetails, CountBySubCategoriesReq, CountBySubCategoryGroupDetails, CountBySubCategoryGroupDetailsResponse, DateReqForDashBoard, DateDetailsResponse, DateDetail, CategoryFieldDateReq, DivisionWiseRevenueDetailsResp, DivDetailResponse } from '@analytics-soa/shared-models';
import { ExcelUploadService } from '../excel-upload/excel-upload.service';
import { Category } from '../entities/category-entity';
import { SubCategory } from '../entities/sub-category-entity';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { CategoryDumpModel } from '../repositorys/excel-category-dump.model';
import { SubCategoryDumpModel } from '../repositorys/excel-subcategory-dump.model';
import { DrrExcel } from '../excel-upload/entities/drrexcel.entity';
import { LedgerExcel } from '../excel-upload/entities/ledgerexcel.entity';



@Injectable()
export class RevenueRegisterService {
    constructor(
        @InjectRepository(Category) private categoryRepo: Repository<Category>,
        @InjectRepository(SubCategory) private subCategoryRepo: Repository<SubCategory>,
        @InjectRepository(DrrExcel) private drrExcelRepository: Repository<DrrExcel>,
        @InjectRepository(LedgerExcel) private ledgerExcelRepository: Repository<LedgerExcel>,
        private excelUploadService: ExcelUploadService,
    ) {

    }
    async getDrrReport(reqObj: DrrRequest): Promise<DrrDetailsResponse> {
        // console.log(reqObj);
        // get categories
        // loop through each category 
        // get each sub category for category
        // date , division, plant, category, sub category
        // 1. day
        // 2. mtd
        // 3. ytd
        const categories = await this.categoryRepo.find({ where: { clientCode: reqObj.clientCode } });
        const categoryDetail = [];

        for (const category of categories) {
            const subCategoryDetails = [];
            const subCategories = await this.subCategoryRepo.find({ where: { clientCode: reqObj.clientCode, categoryId: category.id } });
            for (const subCategory of subCategories) {
                // console.log(subCategory.subCategoryName)
                const drrDetails = await this.excelUploadService.getDRRDetailsForDate(reqObj.date, reqObj.divisionId, reqObj.clientCode, category.id, subCategory.id);
                if (drrDetails) {
                    const subCategoryDetail = new SubcategoryDetails(reqObj.date, category.categoryName, subCategory.subCategoryName.trim(), drrDetails.todayActual, drrDetails.todayBudget, drrDetails.todayLastYear, drrDetails.todayVob, drrDetails.todayVoly, drrDetails.mtdActual, drrDetails.mtdBudget, drrDetails.mtdLastYear, drrDetails.mtdVob, drrDetails.mtdVoly, drrDetails.ytdActual, drrDetails.ytdBudget, drrDetails.ytdLastYear, drrDetails.ytdVob, drrDetails.ytdVoly);
                    subCategoryDetails.push(subCategoryDetail);
                }

            }
            const catDetail = new CategoryDetails(category.categoryName.trim(), subCategoryDetails);
            categoryDetail.push(catDetail);
        }
        if (categoryDetail.length > 0) {
            const drrDetails = new DrrDetails(reqObj.date, categoryDetail);
            if (drrDetails) {
                return new DrrDetailsResponse(true, 0, "Data Retrieved Successfully", drrDetails);
            } else {
                return new DrrDetailsResponse(false, 0, "Something Went Wrong");
            }
        } else {
            return new DrrDetailsResponse(false, 0, "No data found")
        }

    }

    async getIdForCategoryName(cat: CategoryDumpModel): Promise<any> {
        const res = await this.categoryRepo.findOne({
            where: {
                categoryName: cat.categoryName,
                clientCode: cat.clientCode,
                divisionId: cat.divisionId
            }
        });
        if (res) {
            // console.log(res, 'res');
            return res.id;
        } else {
            return 'Category not found';
        }
    }

    async getIdForSubCategoryName(subCat: SubCategoryDumpModel): Promise<any> {
        const res = await this.subCategoryRepo.findOne({
            where: {
                subCategoryName: subCat.subCategoryName,
                clientCode: subCat.clientCode,
                divisionId: subCat.divisionId
            }
        });
        if (res) {
            // console.log(res, 'res');
            return res.id;
        } else {
            return 'Subcategory not found';
        }

    }
    async getSubCategoryWiseActBudRevenueTotals(req: DateDevIdClientCodeIsTotalReq): Promise<TotalSubCatWiseActBudgetRevResponse> {
        const query = this.drrExcelRepository.createQueryBuilder('rr').select('c.`category_name` AS categoryName, sc.`sub_category_name` AS subCategoryName, rr.`tdy_actual_revenue` AS tdyActRevenue , rr.`tdy_budget` AS tdyBudget, rr.mtd_actual as mtdActual')
            .leftJoin(`sub_category`, `sc`, 'sc.`id` = rr.`sub_category_id`')
            .leftJoin(`category`, `c`, 'c.`id` = rr.`category_id`')
            .where(`DATE = '${req.date}' AND rr.division_id = '${req.divisionId}' AND rr.client_code = '${req.clientCode}' AND sc.is_total = '${req.isTotal}' AND sc.is_main = 1`);

        const data: TotalSubCategoryActBudRevenue[] = await query.getRawMany();
        if (data) {
            return new TotalSubCatWiseActBudgetRevResponse(true, 0, 'Data Retrieve Successfully', data)
        } else {
            return new TotalSubCatWiseActBudgetRevResponse(false, 0, "Something went wrong")
        }
    }

    async getSubCategoryWiseActRevenue(req: DateDevIdClientCodeIsTotalReq): Promise<SubCategoryWiseActRevenueResponse> {
        const query = this.drrExcelRepository.createQueryBuilder('rr').select('c.`category_name` AS categoryName, sc.`sub_category_name` AS subCategoryName, rr.`tdy_actual_revenue` AS tdyActualRevenue , rr.`tdy_last_year_revenue` AS tdyLastYearRevenue, rr.`mtd_actual` AS mtdActual ,rr.`mtd_last_year` AS mtdLastYear , rr.`ytd_actual` AS ytdActual ,  rr.`ytd_last_year` AS ytdLastYear ,  rr.`tdy_vob` AS tdyVob , rr.`mtd_vob` AS mtdVob , rr.`ytd_vob` AS ytdVob , rr.`tdy_voly` AS tdyVoly , rr.`mtd_voly` AS mtdVoly ,  rr.`ytd_voly` AS ytdVoly')
            .leftJoin(`sub_category`, `sc`, 'sc.`id` = rr.`sub_category_id`')
            .leftJoin(`category`, `c`, 'c.`id` = rr.`category_id`')
            .where(`DATE = '${req.date}' AND rr.division_id = '${req.divisionId}' AND rr.client_code = '${req.clientCode}' AND sc.is_total = '${req.isTotal}'`);

        const data: SubCategoryWiseActRevenue[] = await query.getRawMany();
        if (data) {
            return new SubCategoryWiseActRevenueResponse(true, 0, 'Data Retrieve Successfully', data)
        } else {
            return new SubCategoryWiseActRevenueResponse(false, 0, "Something went wrong")
        }
    }

    async getSubCategoryWiseActAndBudgetRevenue(req: SubCategoryWiseActAndBudgetRevenueReq): Promise<SubCategoryWiseActAndBudgetRevenueResponse> {
        const query = this.drrExcelRepository.createQueryBuilder('rr').select('c.`category_name` AS categoryName , SUM(rr.`tdy_actual_revenue`) AS actual , SUM(rr.`tdy_budget`) budget, SUM(rr.`tdy_last_year_revenue`) AS last_yr_actual, uom')
            .addSelect(`${req.groupBy}(DATE) as date`)
            .leftJoin(`sub_category`, `sc`, 'sc.`id` = rr.`sub_category_id`')
            .leftJoin(`category`, `c`, 'c.`id` = rr.`category_id`')
            .where(`rr.division_id = '${req.divisionId}' AND rr.client_code = '${req.clientCode}' AND rr.category_id = '${req.categoryId}' AND rr.sub_category_id = '${req.subCategoryId}' AND DATE BETWEEN '${req.startDate}' AND '${req.endDate}'`).groupBy(`${req.groupBy}(DATE)`);

        const data: SubCategoryWiseActAndBudgetRevenueDetails[] = await query.getRawMany();
        if (data) {
            return new SubCategoryWiseActAndBudgetRevenueResponse(true, 0, 'Data Retrieve Successfully', data)
        } else {
            return new SubCategoryWiseActAndBudgetRevenueResponse(false, 0, "Something went wrong")
        }
    }

    async getCategoryWiseActAndBudgetForLastThreeYears(req: CategoryWiseActAndBudgetForLastThreeYears): Promise<CategoryWiseActAndBudgetForLastThreeYrsResponse> {
        const query = this.drrExcelRepository.createQueryBuilder('rr').select('YEAR(DATE) as year, sc.`sub_category_name` AS categoryName, SUM(rr.`tdy_actual_revenue`) AS actual, SUM(rr.`tdy_budget`) budget, sc.`is_total` AS isTotal, sc.`is_grand_total`')
            .leftJoin(`sub_category`, `sc`, 'sc.`id` = rr.`sub_category_id`')
            .leftJoin(`category`, `c`, 'c.`id` = rr.`category_id`')
            .where(`rr.division_id = '${req.divisionId}' AND rr.client_code = '${req.clientCode}' AND sc.is_total = '${req.isTotal}' AND YEAR(DATE) > YEAR(DATE_SUB(NOW(), INTERVAL ${req.lastHowManyYears} YEAR)) AND sc.is_grand_total = 0 AND rr.sub_category_id in (11, 32, 23)`).groupBy('`c`.`category_name`, `sc`.`sub_category_name`, YEAR(DATE)').orderBy('budget', 'DESC')
        // .limit(4);

        const data: CategoryWiseActAndBudgetForLastThreeYrsDetails[] = await query.getRawMany();
        if (data) {
            return new CategoryWiseActAndBudgetForLastThreeYrsResponse(true, 0, 'Data Retrieve Successfully', data)
        } else {
            return new CategoryWiseActAndBudgetForLastThreeYrsResponse(false, 0, "Something went wrong")
        }
    }

    async getTotalVOBandVOLYDetails(req: TotalVOBandVOLYDetailsReq): Promise<TotalVOBandVolyDetailsResponse> {
        const query = this.drrExcelRepository.createQueryBuilder('rr').select('SUM(rr.`tdy_vob`) AS vob, SUM(rr.`tdy_voly`)AS voly')
            .addSelect(`${req.groupBy}(DATE) as date`)
            .leftJoin(`sub_category`, `sc`, 'sc.`id` = rr.`sub_category_id`')
            .leftJoin(`category`, `c`, 'c.`id` = rr.`category_id`')
            .where(`rr.division_id = '${req.divisionId}' AND rr.client_code = '${req.clientCode}' AND rr.category_id = '${req.categoryId}' AND rr.sub_category_id = '${req.subCategoryId}' AND DATE BETWEEN '${req.startDate}' AND '${req.endDate}'`).groupBy(`${req.groupBy}(DATE)`);

        const data: TotalVOBandVolyDetails[] = await query.getRawMany();
        if (data) {
            return new TotalVOBandVolyDetailsResponse(true, 0, 'Data Retrieve Successfully', data)
        } else {
            return new TotalVOBandVolyDetailsResponse(false, 0, "Something went wrong")
        }
    }

    async getRevenueDetailsByCategory(req: revenueDetailsByCategoryReq): Promise<RevenueDetailsByCategoryResponse> {
        const query = this.drrExcelRepository.createQueryBuilder('rr').select('c.`category_name` AS categoryName, sc.`sub_category_name` AS subCategoryName , rr.`tdy_actual_revenue` AS tdyActualRevenue , rr.`tdy_budget` as todayBudget, rr.`tdy_last_year_revenue` AS tdyLastYearRevenue , rr.`mtd_actual` AS mtdActual, rr.`mtd_last_year` AS mtdLastYear , rr.`ytd_actual` AS ytdActual, rr.`ytd_last_year` AS ytdLastYear , rr.`tdy_vob` AS tdyVob , rr.`mtd_vob` AS mtdVob, rr.`ytd_vob` AS ytdVob, rr.`tdy_voly` AS tdyVoly ,rr.`mtd_vob` AS mtdVob, rr.`ytd_voly` AS ytdVoly, sc.uom AS uom, rr.mtd_budget, rr.ytd_budget')
            .leftJoin(`sub_category`, `sc`, 'sc.`id` = rr.`sub_category_id`')
            .leftJoin(`category`, `c`, 'c.`id` = rr.`category_id`')
            .where(`DATE = '${req.date}' AND rr.division_id = '${req.divisionId}' AND rr.client_code = '${req.clientCode}' AND sc.is_main = '${req.isMain}' AND rr.category_id = '${req.categoryId}'`).groupBy('rr.`sub_category_id`').orderBy('rr.`sub_category_id`');

        const data: RevenueDetailsByCategoryDetails[] = await query.getRawMany();
        if (data) {
            for (const eachData of data) {
                if (eachData.subCategoryName == 'OCCUPANCY %') {
                    eachData.mtdActual = Number(eachData.mtdActual) * 100;
                    eachData.mtdLastYear = Number(eachData.mtdLastYear) * 100;
                    eachData.mtdVob = Number(eachData.mtdVob) * 100;
                    eachData.tdyActualRevenue = Number(eachData.tdyActualRevenue) * 100;
                    eachData.tdyVob = Number(eachData.tdyVob) * 100;
                    eachData.tdyVoly = Number(eachData.tdyVoly) * 100;
                    eachData.todayBudget = Number(eachData.todayBudget) * 100;
                    eachData.ytdActual = Number(eachData.ytdActual) * 100;
                    eachData.ytdLastYear = Number(eachData.ytdLastYear) * 100;
                    eachData.ytdVob = Number(eachData.ytdVob) * 100;
                    eachData.ytdVoly = Number(eachData.ytdVoly) * 100;
                    eachData.mtd_budget = Number(eachData.mtd_budget) * 100;
                    eachData.ytd_budget = Number(eachData.ytd_budget) * 100;
                    eachData.tdyLastYearRevenue = Number(eachData.tdyLastYearRevenue) * 100;
                }
            }
            return new RevenueDetailsByCategoryResponse(true, 0, 'Data Retrieve Successfully', data)
        } else {
            return new RevenueDetailsByCategoryResponse(false, 0, "Something went wrong")
        }
    }

    async getCountBySubCategoryGroup(req: CountBySubCategoryGroupReq): Promise<CountBySubCategoryGroupDetailsResponse> {
        const query = this.drrExcelRepository.createQueryBuilder('rr').select('sc.`sub_category_name` AS subCategoryName ,rr.`tdy_actual_revenue` AS tdyActualRevenue ,sc.uom AS uom')
            .addSelect(`${req.groupBy}(DATE) as date`)
            .leftJoin(`sub_category`, `sc`, 'sc.`id` = rr.`sub_category_id`')
            .leftJoin(`category`, `c`, 'c.`id` = rr.`category_id`')
            .where(`rr.division_id = '${req.divisionId}' AND rr.client_code = '${req.clientCode}' AND rr.category_id = '${req.categoryId}' AND  DATE BETWEEN '${req.startDate}' AND '${req.endDate}'`)
            .andWhere('rr.sub_category_id IN (:...subCat)', { subCat: req.subCategoryIds })
            .groupBy(`${req.groupBy}(DATE), rr.sub_category_id`)
            .orderBy('rr.`sub_category_id`');

        const data: CountBySubCategoryGroupDetails[] = await query.getRawMany();
        if (data) {
            return new CountBySubCategoryGroupDetailsResponse(true, 0, 'Data Retrieve Successfully', data)
        } else {
            return new CountBySubCategoryGroupDetailsResponse(false, 0, "Something went wrong")
        }
    }
    async getCountBySubCategories(req: CountBySubCategoriesReq): Promise<CountBySubCategoriesResponse> {
        const query = this.drrExcelRepository.createQueryBuilder('rr').select('sc.`sub_category_name`  AS subCategoryName ,rr.`tdy_actual_revenue` AS tdyActualRevenue ,sc.uom AS uom')
            .leftJoin(`sub_category`, `sc`, 'sc.`id` = rr.`sub_category_id`')
            .leftJoin(`category`, `c`, 'c.`id` = rr.`category_id`')
            .where(`DATE = '${req.date}' AND rr.division_id = '${req.divisionId}' AND rr.client_code = '${req.clientCode}' AND rr.sub_category_id = '${req.subCategoryId}' IN (3, 1) AND rr.category_id = '${req.categoryId}'`).groupBy('rr.`sub_category_id`,`DATE`').orderBy('rr.`sub_category_id`');

        const data: CountBySubCategoriesDetails[] = await query.getRawMany();
        if (data) {
            return new CountBySubCategoriesResponse(true, 0, 'Data Retrieve Successfully', data)
        } else {
            return new CountBySubCategoriesResponse(false, 0, "Something went wrong")
        }
    }

    async getDateDetailsForReport(req: DateReqForDashBoard): Promise<DateDetailsResponse> {
        const query = this.drrExcelRepository.createQueryBuilder('rr').select('Date(MAX(DATE)) AS latestDate')
            .where(` rr.division_id = '${req.divisionId}' AND rr.client_code = '${req.clientCode}'`)

        const data: DateDetail = await query.getRawOne();
        // console.log(data)
        // console.log(moment(data.latestDate).format('YYYY-MM-DD'))
        // data.latestDate = moment(data.latestDate).format('YYYY-MM-DD')
        // const data: DateDetail = await query.getRawOne();
        if (data) {
            return new DateDetailsResponse(true, 0, 'Data Retrieve Successfully', data)
        } else {
            return new DateDetailsResponse(false, 0, "Something went wrong")
        }
    }


    async getDivisionLevelCategoryDetails(req: CategoryFieldDateReq): Promise<DivDetailResponse> {
        const query = this.drrExcelRepository.createQueryBuilder('rr')
            .select('c.`category_name`, `tdy_budget`, `tdy_actual_revenue`, `mtd_actual`, `ytd_actual`, tdy_last_year_revenue,  `mtd_budget`, `mtd_last_year`, `ytd_budget`, `ytd_last_year`')
            .leftJoin(`sub_category`, `sc`, 'sc.`id` = rr.`sub_category_id`')
            .leftJoin(`category`, `c`, 'c.`id` = rr.`category_id`')
            .where(`DATE = '${req.date}' AND rr.division_id = '${req.divisionId}' AND rr.client_code = '${req.clientCode}'  AND sc.sub_category_name  LIKE '%${req.categoryKey}%'`).groupBy('c.`category_name`').orderBy('rr.tdy_actual_revenue');
        const data: DivisionWiseRevenueDetailsResp[] = await query.getRawMany();
        if (data) {
            return new DivDetailResponse(true, 0, 'Data Retrieve Successfully', data)
        } else {
            return new DivDetailResponse(false, 0, "Something went wrong")
        }

    }
    async getAdminDrrReport(reqObj: { date: string }): Promise<any> {
        const query = this.drrExcelRepository.createQueryBuilder().select(`division_id,sub_category_id, tdy_actual_revenue , tdy_budget , tdy_vob , tdy_voly,date`)
            .where(`date = '${reqObj.date}'`)
            .groupBy(`division_id ,sub_category_id`)
        const data = await query.getRawMany();

        if (data) {
            return {
                data
            };
        } else {
            return (`There is no data with '${reqObj.date}'`);
        }
    }

    async getLedgerReport(reqObj: DrrRequest): Promise<any> {
        const data = await this.ledgerExcelRepository.find({ where: { clientCode: reqObj.clientCode, divisionId: reqObj.divisionId, date: reqObj.date } })
        return data;
    }

}
